import { StreamChat } from 'stream-chat'
import { userState } from './stores'
import { GetChatClientOptions } from './types'


const videoApiKey = 'x3jwmavdjc4j'
 
const fakeUsers = [
 
  {
    id: 'kenzo',
    name: 'Kenzo Server',
    token:
      'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoia2Vuem8ifQ.lf1_Nq6kcKZ3wSqRLRKybQa1_sP6UWfIj_kbPC2ggUk',
  },
  {
    id: 'kenzo-ymagawa',
    name: 'Kenzo Ymagawa',
    token:
      'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoia2Vuem8teW1hZ2F3YSJ9.yzyDdWMv6p4rYxYupBdtr4WwL2Z_WiCTAHkQUvEt5O0',
  },
  {
    id: 'paulo-souza',
    name: 'Paulo Souza',
    token:
      'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoicGF1bG8tc291emEifQ.Y_JRkoOY3jbJYUrohSyC3APH0dANHNXfmsFlJGPcgRo',
  },
  {
    id: 'danilo-melo',
    name: 'Danilo Melo',
    token:
      'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoiZGFuaWxvLW1lbG8ifQ.lywyFouzpJKxPUCXzPTCC1mkqDyk_uRaDBIU6y73o_s',
  },
  {
    id: 'luiz-felipe',
    name: 'Luiz Felipe',
    token:
      'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoibHVpei1mZWxpcGUifQ.JTUHMaDJO4P3zGO7MVeTBDry79konEDqTSvTW4kHon0',
  },
  {
    id: 'gabriel-jesus',
    name: 'Gabriel Jesus',
    token:
      'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoiZ2FicmllbC1qZXN1cyJ9.G8HJIf2PezWJIWdxrhAQYlnjxSARygqC1-RiOWhCjbw',
  },
  {
    id: 'gabriel-takuya',
    name: 'Gabriel Takuya',
    token:
      'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoiZ2FicmllbC10YWt1eWEifQ.hP3xNKMW-3ZmvRRMVXlRY_mzc4vY56BD9lDdOy1JBmY',
  },
  {
    id: 'paulo-ios',
    name: 'Paulo iOS',
    token:
      'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoicGF1bG8taW9zIn0.HBtwXCgj6iIUpFYeFIKvuFn2934jyppWZaluLdLr8aw',
  },
  {
    id: 'paulo-android',
    name: 'Paulo Android',
    token: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoicGF1bG8tYW5kcm9pZCJ9.WqnTOTdkm5xHnurYJROH2JxAe99-kJJEyi88yKNsAGE'
  }
]

function getFakeUserById(id: string) {
  return fakeUsers.find(user => user.id === id)
}

const chatUser = getFakeUserById('paulo-souza')

export const ChatConfig = {
  loggedUser: chatUser,
  fakeUsers,
  getFakeUserById,
  isEmulator: false, // This can be set based on the environment
  videoApiKey
}
 

export function getChatUser() {
  return userState.get()
}

export const getChatClient = async (apiKey: string, options?: GetChatClientOptions) => {
  const { connectUser = true } = options ?? {}
  const client = StreamChat.getInstance(apiKey)
  const user = getChatUser()
  const mismatchUser = user && client.user && user.id !== client.user.id

  if (mismatchUser) {
    console.log(`User mismatch detected: current user is ${user?.name}, but client user is ${client.user?.name}`)
    await client.disconnectUser()
  }

  if (!client.user && user) {
    if (connectUser) {
      await client.connectUser({
        id: user.id,
        name: user.name,

      }, user.access_token)
      console.log(`Connected user ${user.name} to Chat client`)
    } else {
      client._setUser({
        id: user.id,
        name: user.name,

      })
      await client._setToken({
        id: user.id,
        name: user.name,
      }, user.access_token)
      console.log(`Set user ${user.name} to Chat client without connecting`)
    }

  } else if (client.userID && !client.wsConnection?.isHealthy) {
    // Warm-start reconnect race: the notifee push handler mounts <ChatChannel>
    // BEFORE `<Chat>`'s `useIsOnline` gets a chance to re-open the WSS on
    // AppState foreground, so <MessageInput> throws "You can't use a channel
    // after client.disconnect() was called" (see `70fe6f1f`). `openConnection`
    // is idempotent, so awaiting it here from the notifee path is safe even
    // if `useIsOnline` also calls it — both await the same wsPromise.
    console.log(`Chat client for ${user?.name ?? client.userID} has no healthy WSS — awaiting openConnection() before returning`)
    try {
      await client.openConnection()
    } catch (e) {
      console.warn(`Chat client openConnection failed`, e)
    }
  }

  return client
}